import { render, staticRenderFns } from "./CommunityRow.vue?vue&type=template&id=90365d04&scoped=true&"
import script from "./CommunityRow.vue?vue&type=script&lang=js&"
export * from "./CommunityRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90365d04",
  null
  
)

export default component.exports